import { createFileRoute } from '@tanstack/react-router'
import { ShiftReviewQueuePage } from '@/features/scheduler/pages/shift-review-queue'

export const Route = createFileRoute(
  '/_authenticated/_organization/scheduler/review-queue'
)({
  component: ShiftReviewQueuePage,
})
